import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useIndicateEmploymentStatus from '../../../../hooks/dashboard/driver-list/useIndicateEmploymentStatus';
import {
  IndicateEmploymentStatusDataType,
  IndicateEmploymentStatusInitialValues,
  IndicateEmploymentStatusSchema,
} from '../../../../models/dashboard/driver-list/indicate-employment-status';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import CustomSelectField from '../../../FormCom/CustomSelectField';
import { FormComponent } from '../../../FormCom/FormComponent';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface IndicateEmploymentStatusModalProps {
  data: any;
}

const IndicateEmploymentStatusModal: React.FC<
  IndicateEmploymentStatusModalProps
> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const { indicateEmploymentStatus, loading } = useIndicateEmploymentStatus();

  const onSubmit = (values: IndicateEmploymentStatusDataType) => {
    indicateEmploymentStatus(values, data?.driverId ?? '', () =>
      modalContext?.setShowModal(false),
    );
  };

  return (
    <ModalContainer label='Update Employment Status'>
      <FormComponent
        initialValues={IndicateEmploymentStatusInitialValues}
        schema={IndicateEmploymentStatusSchema}
        onSubmit={onSubmit}
      >
        <CustomSelectField
          name='employmentType'
          id='employmentType'
          label='Employment type:'
          optionData={['Exclusive', 'Gig']}
        />
        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            btnType='button'
            onClick={() => modalContext?.setShowModal(false)}
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton loading={loading} className='fill'>
            Indicate Status{' '}
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  /* margin-left: auto; */
`;

export default IndicateEmploymentStatusModal;
